import type { IHttpClient } from '@wix/http-client';
import {
  ITemplateRepository,
  LoadTemplatesParams,
  QueryTemplatesParams,
  SearchTemplatesParams,
} from './proto/ITemplateRepository';
import { queryTemplates } from '@wix/ambassador-funnel-templates-gallery-v2-template/http';
import { monitorRequest } from '../../monitoring/request';
import { mapQueryParams, mapQueryResponse } from '../entities/template';

export class HttpTemplateRepository implements ITemplateRepository {
  constructor(private httpClient: IHttpClient) {}

  private async doQuery(params: QueryTemplatesParams) {
    const req = queryTemplates(mapQueryParams(params));
    const res = await this.httpClient.request(req);
    return mapQueryResponse(res.data);
  }

  async loadTemplates(params: LoadTemplatesParams) {
    return monitorRequest(
      params.offset > 0 ? 'paginate-templates' : 'load-templates',
      () => this.doQuery(params),
    );
  }

  async searchTemplates(params: SearchTemplatesParams) {
    return monitorRequest(
      params.offset > 0 ? 'paginate-templates' : 'search-templates',
      () => this.doQuery(params),
    );
  }
}
